import { createContext, useContext, useMemo, useEffect, type ReactNode } from 'react';
import type { ProfileSetupModel } from './ProfileSetupModel';
const Scope = createContext<{
  acquire(create: () => ProfileSetupModel): ProfileSetupModel;
} | null>(null);
/** App-lifetime UI state, with lazy client/model construction and explicit ownership. */
export function AccountProfileScopeProvider({ children }: { children: ReactNode }) {
  const scope = useMemo(() => {
    let model: ProfileSetupModel | undefined;
    return {
      acquire(create: () => ProfileSetupModel) {
        return (model ??= create());
      },
      dispose() {
        model?.dispose();
      },
    };
  }, []);
  useEffect(() => () => scope.dispose(), [scope]);
  return <Scope.Provider value={scope}>{children}</Scope.Provider>;
}
export function useProfileScope(create: () => ProfileSetupModel) {
  const scope = useContext(Scope);
  return useMemo(() => (scope ? scope.acquire(create) : create()), [scope]);
}
